module.exports = __webpack_public_path__ + "img/sustainability.cbbf2161.png";